import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
  selector: '[qmDebounce]'
})
export class DebounceDirective implements OnInit {
  @Output()
  public onDebounce = new EventEmitter<any>();

  @Input('delay')
  public delay = 500;

  private isFirstChange = true;

  constructor(private model: NgControl) {
  }

  ngOnInit(): void {
    this.model.valueChanges.pipe(debounceTime(this.delay), distinctUntilChanged())
      .subscribe(modelValue => {
        if (this.isFirstChange) {
          this.isFirstChange = false;
        } else {
          this.onDebounce.emit(modelValue);
        }
      });
  }

}
